"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runOptionsBuilders = void 0;
var uniq_1 = require("../../utils/uniq");
var setOptionKeysIfNotPreset = function (filter) {
    filter.options.forEach(function (option, index) {
        if (option.key === undefined) {
            option.key = index;
        }
    });
};
var runOptionsBuilder = function (data, rekey, shouldUniqifyOptions) { return function (filter) {
    if (typeof filter.optionsBuilder === 'function' && data) {
        var options = filter.optionsBuilder(data, filter.options || []);
        filter.options = shouldUniqifyOptions ? uniq_1.uniq(options) : options;
    }
    if (rekey && Array.isArray(filter.options) && filter.options.length > 0) {
        setOptionKeysIfNotPreset(filter);
    }
    return filter;
}; };
/**
 * @function runOptionsBuilders
 * Runs optionsBuilder() functions found in filters array
 * and assigns results to .options properties
 * @param {Filter[]} filters
 * @param {data: any} data - data to give to any options builders in the filters array
 */
var runOptionsBuilders = function (filters, data, _a) {
    var _b = _a.rekey, rekey = _b === void 0 ? true : _b, _c = _a.shouldUniqifyOptions, shouldUniqifyOptions = _c === void 0 ? true : _c;
    return filters.forEach(runOptionsBuilder(data, rekey, shouldUniqifyOptions));
};
exports.runOptionsBuilders = runOptionsBuilders;
//# sourceMappingURL=runOptionsBuilders.js.map